import { Alert as MuiAlert, Typography } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import SuccessSvg from './_svgs/Success.svg?react'
import ErrorSvg from './_svgs/Error.svg?react'
import { useAlertStore } from './alertStore'

export const Alert: FC = () => {
  // Use specific selectors to avoid recreating objects
  const type = useAlertStore((state) => state.type)
  const message = useAlertStore((state) => state.message)
  const show = useAlertStore((state) => state.show)
  const id = useAlertStore((state) => state.id)

  const icon = type === 'success' ? <SuccessSvg /> : <ErrorSvg />
  const [display, setDisplay] = useState(false)

  useEffect(() => {
    if (show) {
      setDisplay(true)
      const timeout = setTimeout(() => {
        setDisplay(false)
      }, 5000)

      return () => clearTimeout(timeout)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]) // Ensure effect triggers on each new alert

  if (!display) return null

  return (
    <MuiAlert
      severity={type}
      icon={icon}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 9999,
        borderRadius: '0 0 8px 8px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '8px',
        backgroundColor: type === 'success' ? 'bg-zGreen200' : 'bg-zRed100',
      }}
      onTouchStart={() => setDisplay(false)}
      onClick={() => setDisplay(false)}>
      <Typography
        variant="subtitle2"
        className="text-[14px] leading-[21px] text-zBlack200">
        {message}
      </Typography>
    </MuiAlert>
  )
}
